import { render, staticRenderFns } from "./RequestSport.vue?vue&type=template&id=6ff9d204"
import script from "./js/requestSport.js?vue&type=script&lang=js&external"
export * from "./js/requestSport.js?vue&type=script&lang=js&external"
import style0 from "./RequestSport.vue?vue&type=style&index=0&id=6ff9d204&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports